const timeRegex = /^\d\d:\d\d$/
const twoDigitDateRegex = /\d{1,2}(-|\/|) *\d{1,2}\1 *\d{2}/
const fourDigitDateRegex = /\d{1,2}(-|\/|) *\d{1,2}\1 *\d{4}/

const setDate = (regex, value, yearComplement) => {
  const date = regex.exec(value)
  if (date != null) {
    let time = '00:00'
    const postionOfColon = value.indexOf(':')
    if (postionOfColon > -1) {
      time = value.substr(value.indexOf(':') - 2, 5)
    }
    const splitRegex = /[-*/* *]/
    const splitDates = date[0].split(splitRegex)

    if (splitDates[0].length === 1) {
      splitDates[0] = `0${splitDates[0]}`
    }
    if (splitDates[1].length === 1) {
      splitDates[1] = `0${splitDates[1]}`
    }

    return `${yearComplement}${splitDates[2]}-${splitDates[1]}-${splitDates[0]}T${time}`
  }
  return ''
}

export const returnValueForLineItemField = (
  newValue: string,
  dataType: any,
  currentValue: string
) => {
  switch (dataType) {
    case 'text':
    case 'textarea':
    case 'search':
      return `${currentValue} ${newValue}`.trim()
    case 'datetime-local':
      if (fourDigitDateRegex.test(newValue)) {
        return setDate(fourDigitDateRegex, newValue, '')
      } else if (twoDigitDateRegex.test(newValue)) {
        return setDate(twoDigitDateRegex, newValue, '20')
      }

      if (timeRegex.test(newValue)) {
        const splitDate = currentValue.split('T')
        if (splitDate[0]) {
          return `${splitDate[0]}T${newValue}`
        }
      }
      break
    case 'number': {
      const cleanedValue = newValue.trim()
      const indexOfFirstNonNumerical = cleanedValue.search(/[^0-9.]/)

      return indexOfFirstNonNumerical === 0
        ? currentValue
        : indexOfFirstNonNumerical > 0
          ? cleanedValue.substring(0, indexOfFirstNonNumerical)
          : cleanedValue
    }
  }
  return currentValue
}

export const returnDefaultValueForLineItemField = (
  itemValue,
  lineItemValue
) => {
  return lineItemValue ? lineItemValue : itemValue
}
